import _ from "lodash";

// tslint:disable-next-line:no-namespace
declare global {

    interface Array<T> {
        getUniqueListOfObjects(prop): T[];
        getUnique(): T[];
        remove(val): T[];
    }

}

Array.prototype.getUniqueListOfObjects = function (prop) {

    var unique = [];

    if (prop) {
        for (let i = 0; i < this.length; i++) {
            if (unique.indexOf(this[i][prop]) === -1) {
                unique.push(this[i]);
            }
        }
    } else {
        for (let i = 0; i < this.length; i++) {
            if (unique.indexOf(this[i]) === -1) {
                unique.push(this[i]);
            }
        }
    }

    return unique;
};

Array.prototype.getUnique = function () {
    var u = {}, a = [];
    for (var i = 0, l = this.length; i < l; ++i) {
        if (u.hasOwnProperty(this[i])) {
            continue;
        }
        a.push(this[i]);
        u[this[i]] = 1;
    }
    return a;
};

Array.prototype.remove = function (val) {
    var i = this.indexOf(val);
    return i > -1 ? this.splice(i, 1) : [];
};
